import DOMPurify from 'isomorphic-dompurify'
import VueDOMPurifyHTML from 'vue-dompurify-html'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(
    VueDOMPurifyHTML,
    {
      default: {
        ALLOWED_TAGS: [
          // Basic formatting
          'p',
          'div',
          'span',
          'strong',
          'b',
          'em',
          'i',
          'u',
          'strike',
          'del',
          'ins',
          // Lists
          'ul',
          'ol',
          'li',
          // Headers
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
          'h6',
          // Other common elements
          'br',
          'hr',
          'blockquote',
          'code',
          'pre',
          // Table elements
          'table',
          'thead',
          'tbody',
          'tr',
          'th',
          'td',
        ],
      },
      namedConfigurations: {},
      enableSSRPropsSupport: true,
    },
    () => DOMPurify,
  )
})
